/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dropdailyattemptstoday3Inputs */

const en_dropdailyattemptstoday3 = /** @type {(inputs: Dropdailyattemptstoday3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tries today`)
};

const de_dropdailyattemptstoday3 = /** @type {(inputs: Dropdailyattemptstoday3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Versuche heute`)
};

/**
* | output |
* | --- |
* | "Tries today" |
*
* @param {Dropdailyattemptstoday3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const dropdailyattemptstoday3 = /** @type {((inputs?: Dropdailyattemptstoday3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dropdailyattemptstoday3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dropdailyattemptstoday3(inputs)
	return de_dropdailyattemptstoday3(inputs)
});
export { dropdailyattemptstoday3 as "dropDailyAttemptsToday" }